import authority from './authority'

export default {

  beginMenu: [
    {
      name: '查看',
      command: authority.READ_WORK
    },
    {
      name: '查看/编辑',
      command: authority.READ_EDIT
    },
    {
      name: '派工确认',
      command: authority.CONFIRM_WORK,
      mobile: true
    }
  ],

  runMenu: [
    {
      name: '查看',
      command: authority.READ_WORK
    },
    {
      name: '查看/增项',
      command: authority.READ_ADD_PARTS
    },
    {
      name: '改派',
      command: authority.DISPATCH,
      mobile: true
    },
    {
      name: '推进',
      command: authority.PUSH,
      mobile: true
    },
    {
      name: '中断',
      command: authority.INTERRUPT,
      mobile: true
    },
    {
      name: '终止',
      command: authority.STOP,
      mobile: true
    },
    {
      name: '退回',
      command: authority.BACK,
      mobile: true
    },
    {
      name: '转机修',
      command: authority.MACHINE_REPAIR,
      mobile: true
    },
    {
      name: '完工',
      command: authority.END_WORK,
      mobile: true
    }
  ],

  waitMenu: [
    {
      name: '查看',
      command: authority.READ_WORK
    },
    {
      name: '查看/增项',
      command: authority.READ_ADD_PARTS
    },
    {
      name: '改派',
      command: authority.DISPATCH,
      mobile: true
    },
    {
      name: '推进',
      command: authority.PUSH,
      mobile: true
    },
    {
      name: '返工',
      command: authority.REWORK,
      mobile: true
    },
    {
      name: '撤回',
      command: authority.WITHDRAW
    },
    {
      name: '开工',
      command: authority.START_WORK,
      mobile: true
    },
    {
      name: '退回',
      command: authority.BACK,
      mobile: true
    }
  ],

  // 中断

  interruptMenu: [
    {
      name: '查看',
      command: authority.READ_WORK
    },
    {
      name: '查看/增项',
      command: authority.READ_ADD_PARTS
    },
    {
      name: '改派',
      command: authority.DISPATCH,
      mobile: true
    },
    {
      name: '推进',
      command: authority.PUSH,
      mobile: true
    },
    {
      name: '开工',
      command: authority.START_WORK,
      mobile: true
    }
  ],

  // 等待机修
  machineRepairWaitMenu: [
    {
      name: '查看',
      command: authority.READ_WORK
    },
    {
      name: '查看/增项',
      command: authority.READ_ADD_PARTS
    },
    {
      name: '改派',
      command: authority.DISPATCH,
      mobile: true
    },
    {
      name: '推进',
      command: authority.PUSH,
      mobile: true
    },
    {
      name: '开工',
      command: authority.START_WORK,
      mobile: true
    }
  ],

  // 正在机修
  machineRepairRunMenu: [
    {
      name: '查看',
      command: authority.READ_WORK
    },
    {
      name: '查看/增项',
      command: authority.READ_ADD_PARTS
    },
    {
      name: '改派',
      command: authority.DISPATCH,
      mobile: true
    },
    {
      name: '推进',
      command: authority.PUSH,
      mobile: true
    },
    {
      name: '完工',
      command: authority.END_WORK,
      mobile: true
    }
  ],

  // 质检

  qualityMenu: [
    {
      name: '查看',
      command: authority.READ_WORK
    },
    {
      name: '质检',
      command: authority.QUALITY,
      mobile: true
    }
  ],

  // 洗车等待

  carWashWaitMenu: [
    {
      name: '查看',
      command: authority.READ_WORK
    },
    {
      name: '开始洗车',
      command: authority.START_WASH,
      mobile: true
    }
  ],

  // 洗车进行中

  carWashMenu: [
    {
      name: '查看',
      command: authority.READ_WORK
    },
    {
      name: '结束洗车',
      command: authority.END_WASH,
      mobile: true
    }
  ],

  // 交车

  deliveryMenu: [
    {
      name: '查看',
      command: authority.READ_WORK
    },
    {
      name: '交车',
      command: authority.DELIVERY,
      mobile: true
    }
  ],

  // 结算

  settlementMenu: [
    {
      name: '查看',
      command: authority.READ_WORK
    },
    {
      name: '结算',
      command: authority.SETTLEMENT,
      mobile: true
    }
  ]
}
